import { render } from "./formtable.vue?vue&type=template&id=fe5338b4&scoped=true"
import script from "./formtable.vue?vue&type=script&lang=js"
export * from "./formtable.vue?vue&type=script&lang=js"

import "./formtable.vue?vue&type=style&index=0&id=fe5338b4&scoped=true&lang=css"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5338b4"]])

export default __exports__